<template>
    <router-view
        :total_compensation="total_compensation"
        :total_clients="total_clients"
        :average_saved="average_saved"
        :reviews="reviews"
        :score="score" />
</template>

<script>
export default {
  name: 'AppRoot',

  props: {
    translations:       { type: Object, required: true },
    back_locale:        { type: String,  required: true },
    countries:          { type: Array,   default: () => [] },
    currencies:         { type: Array,   default: () => [] },
    total_compensation: { type: String,  default: '' },
    total_clients:      { type: String,  default: '' },
    average_saved:      { type: String,  default: '' },
    reviews:            { type: Number,  default: null },
    score:              { type: Number,  default: null },
  },

  created() {
    // Bootstrap locale & i18n from server
    this.$store.commit('updateField', { path: 'locale', value: this.back_locale });
    const { locale, message } = this.translations;
    this.$i18n.setLocaleMessage(locale, message);
    this.$i18n.locale = locale;

    // Bootstrap lookup data into the relevant store modules
    if (this.countries.length) {
      this.$store.commit('round1/updateField', { path: 'countriesCodes', value: this.countries });
    }

    if (this.currencies.length) {
      this.$store.commit('round2/updateField', { path: 'currencies', value: this.currencies });
    }
  },
}
</script>
